import { render, staticRenderFns } from "./CSVFilePickerField.vue?vue&type=template&id=22646ee2&"
import script from "./CSVFilePickerField.vue?vue&type=script&lang=js&"
export * from "./CSVFilePickerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports